import React, { useMemo, useRef, useState } from "react";
import { Box, css, Flex, Icon, Text } from "@storyofams/react-ui";
import Image from "next/image";
import ReactPlayer from "react-player";
import { Button } from "~components/common/Button";
import { EarthCoins, NhPlay } from "~components/common/Icons";
import { Video } from "~components/common/Story/blocks/Video";
import { VideoModal } from "~components/common/Story/components/VideoModal";
import { ImageModal } from "~components/product/Reviews/Reviews/ImageModal";

export const Steps = ({ steps, video = "" }) => {
  const [image, setimage] = useState(null);
  const [isOpenVideo, setIsOpenVideo] = useState<boolean>(false);
  const player = useRef(null);
  const instructions = useMemo(
    () =>
      steps
        .sort((a, b) =>
          a?.step_order ? a.step_order - b.step_order : a.id - b.id
        )
        .map(({ text_content, photo, video }) => ({
          text: text_content.text,
          photo,
          video,
        }))
        .filter(({ text }) => text),
    [steps]
  );
  return (
    <Box mb={[0, "48px"]}>
      <Flex
        mt={[0, "48px"]}
        mb={[0, 2]}
        alignItems={"center"}
        flexDirection={["column", "row"]}
        justifyContent={"space-between"}
      >
        <Text
          display={["none", "block"]}
          fontFamily={"DINPro"}
          fontWeight={700}
          fontSize={"24px"}
        >
          Instructies
        </Text>
        {video && (
          <Box
            flex="none"
            fontSize="16px"
            alignItems={"center"}
            fontWeight={500}
            backgroundColor={"white"}
            border="1px solid black"
            lineHeight="22.4px"
            width={["100%", "max-content"]}
            display={"flex"}
            justifyContent={"center"}
            py="7.3px"
            cursor={"pointer"}
            textColor={"black"}
            px="37.5px"
            mb={[3, 0]}
            borderRadius={"md"}
            onClick={() => setIsOpenVideo(true)}
          >
            <Icon
              top={0}
              position={"relative"}
              fontSize={"20px"}
              icon={NhPlay}
              mr={"12px"}
            />
            Play Video
          </Box>
        )}
      </Flex>
      <Box
        border={"1px solid #E2DFDF"}
        borderRadius={"8px"}
        overflow={"hidden"}
      >
        {instructions.map(({ text, photo, video }, index) => (
          <Flex
            flexDirection={["column", "row"]}
            backgroundColor={index % 2 === 0 && "#FCF9F7"}
            py={["15px", "24px"]}
            px={[2, 0]}
            key={text + index}
            flex={"none"}
          >
            <Box
              textAlign={"center"}
              width={["max-content", "70px"]}
              flex="none"
              mb={[1, 0]}
              fontWeight={700}
              fontSize={"20px"}
              lineHeight={"26px"}
            >
              {index + 1}
            </Box>
            <Flex flexDirection={["column", "row"]} pr={[0, "32px"]}>
              <Text
                fontSize={["16px", "18px"]}
                color={"#1D1D1BCC"}
                lineHeight={["22.4px", "25.2px"]}
                maxWidth={["none", "690px"]}
                mb={["10px", 0]}
                dangerouslySetInnerHTML={{ __html: text }}
              ></Text>
              {photo && (
                <Box
                  cursor="pointer"
                  onClick={() => setimage(photo)}
                  css={css({
                    img: {
                      borderRadius: "md",
                    },
                  })}
                  ml={[0, "93px"]}
                  flex="none"
                >
                  <Image width={180} height={135} src={photo} alt="d" />
                </Box>
              )}
              {video && (
                <Box
                  mr={[0, "32px"]}
                  overflow={"hidden"}
                  width={["100%", 180]}
                  borderRadius={"md"}
                  height={["100%", 130]}
                  flex={"none"}
                  ml={[0, "24px"]}
                >
                  <Video
                    content={{
                      url: video,
                    }}
                  />
                </Box>
              )}
            </Flex>
          </Flex>
        ))}
      </Box>
      <Box
        display={["none", "flex"]}
        border="1px solid grey200"
        p="13.2px 16px"
        borderRadius="md"
        mt={[1, 2]}
      >
        <Icon
          mr={["10px", "24px"]}
          fontSize={"23px"}
          icon={EarthCoins}
          color="black"
        />
        <Box lineHeight={"22.4px"}>
          <Text mr={0.5} display={"inline"}>
            {"Ga jij dit recept volgen? Deel je foto’s "}
            <Button
              variant="link"
              fontSize={2}
              mr={0.5}
              textDecoration={"underline"}
              href={"https://community.naturalheroes.nl/"}
            >
              in de community
            </Button>
            {"er ontvang punten! "}
          </Text>
        </Box>
      </Box>
      <ImageModal image={image} isOpen={!!image} close={() => setimage(null)} />
      <VideoModal isOpen={isOpenVideo} close={() => setIsOpenVideo(false)}>
        <ReactPlayer
          ref={player}
          url={video}
          playing={true}
          width={"100%"}
          height={"100%"}
          controls
          config={{
            youtube: {
              playerVars: {
                modestbranding: 1,
                controls: true,
              },
            },
          }}
        />
      </VideoModal>
    </Box>
  );
};
